module.exports = __webpack_public_path__ + "prod/1.42.2/img/solutionLb.76129fdc.png";